module.exports = "\n<ul class=\"list1\" id=\"menu\">\n  <li class=\"list-inline-item\" *ngFor=\"let p of pageList\">\n    <a class=\"nav-link\" href=\"\" routerLink=\"{{p.KP_Redirect_URL}}\" routerLinkActive=\"menu-active\">\n      <span>{{p.KHB_Page}}</span>\n    </a>\n  </li>\n</ul>\n\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/masters.component.html
// module id = ./src/app/masters/masters.component.html
// module chunks = main